const TIER_DISCOUNTS = {
  bronze: { license: 15, hosting: 10 },
  silver: { license: 20, hosting: 15 },
  gold:   { license: 25, hosting: 15 },
};

function toNum(v) {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
}

function parseTier(value) {
  if (!value) return null;
  const s = String(value).toLowerCase();
  if (s.includes("gold"))   return "gold";
  if (s.includes("silver")) return "silver";
  if (s.includes("bronze")) return "bronze";
  return null;
}

function findPartner(partners, partnerId) {
  if (!partnerId || !Array.isArray(partners)) return null;
  const pid = String(partnerId);
  return partners.find(
    (p) => p && String(p.PartnerId ?? p.PartnerID ?? p.ResellerID ?? p.id) === pid,
  ) ?? null;
}

export function getPartnerDiscounts(partners, partnerId) {
  const p = findPartner(partners, partnerId);
  if (!p) return { licenseDiscountPercent: 0, hostingDiscountPercent: 0 };

  const tier = parseTier(p.PartnerLevelCode ?? p.PartnerLevelName);
  if (tier) {
    return {
      licenseDiscountPercent: TIER_DISCOUNTS[tier].license,
      hostingDiscountPercent: TIER_DISCOUNTS[tier].hosting,
    };
  }

  return {
    licenseDiscountPercent: toNum(p.DiscountPercent),
    hostingDiscountPercent: 0,
  };
}

export function applyPartnerDiscount(price, discountPercent) {
  const retail   = toNum(price);
  const discount = Math.min(100, Math.max(0, toNum(discountPercent)));
  return retail - (retail * discount) / 100;
}
